import React from 'react';

export default function AdminTabs({ selected, onChange }) {
  return <div className='admin-page-switch switch d-flex align-items-stretch text-center mt-4 p-1 mb-3'
    role='group' aria-label='Admin sections'>
    {[
      ['pending', 'Pending Results'],
      ['review', 'Review Results'],
      ['corrections', 'Corrections'],
      ['marketing', 'Marketing Emails'],
    ].map(([value, label]) => <button key={value} type='button'
      className={`p-2 wallet border-0 ${selected === value ? 'bg-lightgreen' : ''}`}
      aria-pressed={selected === value} onClick={() => onChange(value)}>{label}</button>)}
  </div>;
}
